import { default as doTeamModalModel } from './teamModal';

export const sagaTeamModal = doTeamModalModel.sagas;
